// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const sandaconda: PokeData = {
  "id": 844,
  "name": "sandaconda",
  "height": 38,
  "weight": 655,
  "base_experience": 179,
  "types": [
    PokeType.GROUND
  ],
  "api_moves": [
    "slam",
    "sand-attack",
    "headbutt",
    "wrap",
    "dig",
    "minimize",
    "skull-bash",
    "glare",
    "sandstorm",
    "sand-tomb",
    "coil",
    "bulldoze",
    "brutal-swing"
  ],
  "moves": [
    "headbutt",
    "sandstorm",
    "mud-slap",
    "mud-shot",
    "rototiller",
    "earthquake",
    "earth-power",
    "bonemerang",
    "bone-throw",
    "mud-bomb",
    "fissure",
    "magnitude"
  ],
  "evolution_chain": {
    "id": 443,
    "item": null,
    "species": [
      {
        "name": "silicobra",
        "order": 843,
        "types": [
          PokeType.GROUND
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "sandaconda",
        "order": 844,
        "types": [
          PokeType.GROUND
        ],
        "evolves_from_species_id": 843,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 36,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 129,
    "speed": 108,
    "ability_power": 163
  },
  "stat_changes": [],
  "catch_rate": 120,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
